import React from 'react';
import { withNamespaces } from 'react-i18next';

function FooterStart({ language, t }) {
	return (
		<footer>
			<div className="footer-section">
				<div className="item item-1">
					<a href="/imprint">{t('imprint')}</a>
					<span>,&nbsp;</span>
					<a href="/datenschutz">{t('data & privacy')}</a>
				</div>
				<div className="item item-2">
					<p>©2021 by Reinhild Buchmayer</p>
				</div>
				<div className="item item-3">
					{t('created by')}
					<a href="https://www.dreher-media.de/" target="_blank" rel="noopener noreferrer">
						<img src="img/Schriftzug-dm.png" alt="logo dreher.media" />
					</a>
				</div>
			</div>
		</footer>
	);
}

export default withNamespaces()(FooterStart);
